<template>
  <div>
    <div>Vui lòng chờ khách hàng ký hợp đồng và nhập kết quả vào bên dưới:</div>
    <div class="field-label step5-handle-file-contract mt-4 m-10 p-4 rounded" style="border: #5E00B6 solid 2px; box-shadow: 0px 12px 11px rgba(0, 0, 0, 0.25);">
      <div>
        <label class="w-100">Kết quả xử lý <span class="text-danger"> *</span></label>
        <el-select class="w-50" v-model="formStep5.result" placeholder="Chọn kết quả xử lý">
          <el-option
              v-for="item in resultHandle"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="mt-4">
        <label>Ghi chú <span class="text-danger"> *</span></label>
        <ckeditor :editor="editor"  v-model="formStep5.note"></ckeditor>
      </div>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <el-button style="background-color: #CACACA" @click="clear()" size="mini" class="rounded">Hủy</el-button>
        <el-button style="background-color: #5D04B0" @click="saveStep5" class="text-white rounded" size="mini">
          <i :class="loadingStep5 ? 'el-icon-loading' : ''"></i>
          Lưu kết quả
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomEditor from "@/core/plugins/ckeditor5/custom-editor";
import {SIGN_CONTRACT_CITIME} from "../../../../core/services/store/customer/customer-crm.module";

export default {
  name: "step5HandleFileContract",
  components: {
    result: '',
  },
  data() {
    return {
      editor: CustomEditor,
      formStep5: {
        result: 'signed',
        note: '',
      },
      loadingStep5: false,
      resultHandle: [
        { value: 'signed', label: 'Đã ký hợp đồng' },
      ]
    }
  },

  methods: {
    saveStep5() {
      this.loadingStep5 = true;
      const result = this.formStep5.result ?? '';
      const noteLength = this.formStep5.note ? this.formStep5.note.replace(/<[^>]*>/g, '').trim().length : 0;

      if(!result) {
        this.$notify({
          title: 'Thiếu dữ liệu!',
          message: 'Vui lòng chọn kết quả xử lý!',
          type: 'warning'
        });
        return;
      }

      if(noteLength > 200 || noteLength === 0) {
        this.$notify({
          title: 'Sai dữ liệu!',
          message: noteLength === 0 ? 'Vui lòng nhập ghi chú' : 'Ghi chú không được dài quá 200 kí tự!',
          type: 'warning'
        });
        return;
      }

      const payload = {
        id: this.$route.params.id,
        result: result,
        note: this.formStep5.note,
      };

      this.$store.dispatch(SIGN_CONTRACT_CITIME, payload).then((res) => {
        console.log('erresr', res);

        if (!res.error) {
          this.$notify({
            title: 'Thành công!',
            message: res.message ? res.message : 'Lưu kết quả ký hợp đồng thành công!',
            type: 'success'
          });
          this.$emit('next-step-6');
          this.clear();
          this.loadingStep5 = false;
        }
      }).catch((e) => {
        this.$notify({
          title: 'Thất bại!',
          message: e?.data?.message || 'Lưu kết quả ký hợp đồng thất bại!',
          type: 'error'
        });
        this.loadingStep5 = false;
      }).finally(()=>{

      });
    },

    clear() {
      this.formStep5 = {
        result: '',
        note: '',
      };

    }
  }
}
</script>

<style scoped>
.step5-handle-file-contract {
  text-align: left;
}

.field-label {
  margin-top: 10px;
  text-align: left;
}
</style>


